import * as React from "react";
import { Input as ShadcnInput } from "@/components/ui/input";

import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <ShadcnInput
        type={type}
        className={cn(
          "flex h-14 w-full rounded-xl border border-border bg-white px-4 py-4 ring-offset-background file:border-0 file:bg-transparent file:text-lg file:font-medium placeholder:text-[rgba(34,34,34,0.5)] focus-visible:outline-none focus-visible:ring-0 focus-visible:border-[#6b6ded] disabled:cursor-not-allowed disabled:opacity-50 text-lg md:text-lg",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
